import React from 'react';

const RemoveButton = ({ onClick, style = {} }) => {
  const defaultStyle = {
    position: 'absolute',
    top: '8px',
    right: '8px',
    background: 'transparent',
    color: '#888888',
    border: 'none',
    borderRadius: '4px',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'normal',
    transition: 'all 0.2s ease',
    zIndex: 1,
    ...style
  };

  return (
    <button 
      onClick={onClick} 
      style={defaultStyle}
      onMouseEnter={(e) => {
        e.target.style.fontWeight = 'bold';
        e.target.style.color = '#555555';
      }}
      onMouseLeave={(e) => {
        e.target.style.fontWeight = 'normal';
        e.target.style.color = '#888888';
      }}
    >
      ✕
    </button>
  );
};

export default RemoveButton;
